import { NavLink } from 'react-router-dom';
import { mangaCategories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            漫画分类
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            探索你喜欢的漫画类型，找到属于你的精彩故事
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {mangaCategories.map((cat) => (
            <NavLink
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 hover:bg-accent-50 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm font-medium text-foreground-950 whitespace-nowrap">{cat.name}</h3>
                <p className="text-xs text-foreground-600 mt-1 hidden sm:block">{cat.description}</p>
              </div>
            </NavLink>
          ))}
        </div>
      </div>
    </section>
  );
}